import {
  AppToolbarButton,
  DropdownMenu,
  DropdownMenuOption,
  Icon,
  pxToRem,
  useIsDesktop,
} from '@lbcamden/lib-react';
import { FunctionComponent, useMemo } from 'react';
import { useNavigate } from 'react-router';

import { routes } from '~/client/config/routes';
import { useCurrentUser, useRoleInformation } from '~/client/hooks/storeHooks';
import { logout } from '~/client/lib/auth';

export const UserMenu: FunctionComponent = () => {
  const navigate = useNavigate();

  const user = useCurrentUser();
  const { isNeighbourhoodManager, isPcfra } = useRoleInformation();

  const isDesktop = useIsDesktop();

  const options = useMemo<DropdownMenuOption[]>(
    () =>
      [
        isPcfra && {
          id: 'admin',
          label: 'Management tools',
          onClick: () => navigate(routes.managementTools),
        },
        isNeighbourhoodManager && {
          id: 'activity',
          label: 'Activity report',
          onClick: () => navigate(routes.activityReport),
        },
        isPcfra && {
          id: 'report',
          label: 'Residents report',
          onClick: () => navigate(routes.residentsReport),
        },
        { id: 'logout', label: 'Sign out', onClick: logout },
      ].filter((element) => !!element),
    [user, isNeighbourhoodManager, isPcfra],
  );

  if (!user) {
    return null;
  }

  const renderButton = (isOpen?: boolean) => (
    <AppToolbarButton css={(theme) => ({ gap: theme.spacing(1) })}>
      {isDesktop && (
        <>
          <Icon icon="ui/chevron-light" width={pxToRem(12)} $flipY={isOpen} />
          {user.name}
        </>
      )}
      {!isDesktop && <Icon icon="ui/burger" width={pxToRem(14)} />}
    </AppToolbarButton>
  );

  return <DropdownMenu button={renderButton} options={options} />;
};
